import React from "react"
import BeehiivSubscribeEmbed from "./beehiiv-subscribe-embed"
import "./signup.css"

const Signup = () => {
  return (
    <div className="signup-card">
      <div className="signup-copy">
        <h2 className="signup-title">Like what you read?</h2>
        <p className="signup-text">
          I write about what I find interesting or useful. Currently exploring
          AI a lot
        </p>
      </div>
      <BeehiivSubscribeEmbed className="signup-actions signup-actions--embed" />
    </div>
  )
}

export default Signup
